export const TEXT_ROW_ITEM_BLOCK_NAME = 'bb-loading-indicator-wrapper';
